<template>
  <div class="content-center">
    <div class="banner">
      <div class="content">
        <img src="@/assets/images/about/about_htsk.png" alt="">
        <div class="banner-title">
          以 科技赋能传统企业数字转化型升级 为宗旨
          提供全渠道智能零售云服务解决方案
        </div>
      </div>
    </div>
    <div class="block-01">
      <div class="content">
        <div class="title">公司介绍</div>
        <p class="paragraph">汇通数科智能科技有限公司（以下简称汇通数科）是汇通达网络股份有限公司的全资子公司，<span class="emphasize">立足于通过科技赋能传统企业数字转化型升级宗旨，以智能零售、人工智能、云计算、互联网为技术基础，为传统中小微企业，乡镇夫妻店以及上下游客户提供全渠道智能零售云服务解决方案。</span></p>
        <p class="paragraph">同时围绕零售门店的实际经营场景，建设零售行业门店数字化服务平台。从商品采购、商品销售、会员营销、收银支付等场景出发提供一系列SaaS产品，帮助门店完成数字化改造升级，<span class="emphasize">提升经营效率并最终拉升销量助力门店经营增长。</span></p>
        <p class="paragraph">目前，公司业务范围涵盖SaaS软件服务、技术咨询与开发、精准营销、智能终端软硬件等业务，<span class="emphasize">旗下拥有超级老板、汇享购、小橙支付、汇好看、千橙万店等智能零售服务平台。</span></p>
        <div class="logo">
          <img src="@/assets/images/about/about-logo.png" alt="">
        </div>
        <p class="paragraph"><span class="emphasize">截止2020年底已服务全国21个省，14万家客户，服务数百个品牌，平台服务业务规模数百亿。</span>从数字化赋能乡镇店，促进农村消费提档升级，到构建立足农村市场的产业互联网平台，打造城乡资源流通‘高速公路’，再到培育‘新农商’，通过技能培训培厚人才根基，不断积淀创新优势，激发乡村大地发展潜能。</p>
        <p class="paragraph">新发展阶段，推动乡村振兴征途如虹、使命重大，<span class="emphasize">汇通数科将始终如一，与国家战略同频共振，与农民美好生活互促共荣。</span></p>
      </div>
    </div>
  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
export default {
  metaInfo: metaInfo.Introduce,
  name: 'AboutUs',
  data() {
    return {}
  },
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.banner {
  background: url("~@/assets/images/about/about_banner.png") no-repeat center;
  background-size: 100% 100%;
  min-width: 1200px;
  padding: 112px 0;
  .content {
    width: 1200px;
    margin: 0 auto;
    img {
      display: block;
      width: 114px;
    }
    .banner-title {
      width: 392px;
      height: 73px;
      font-size: 20px;
      color: #FFFFFF;
      line-height: 28px;
      margin-top: 40px;
    }
  }
  img {
    display: block;
    width: 100%;
  }
}
.block-01 {
  width: 100%;
  background: #fff;
  .content {
    .logo {
      img {
        display: block;
        width: 355px;
        height: 120px;
        margin: 0 auto;
      }
    }
  }
}
.content {
  width: 900px;
  margin: 58px auto 69px;
  color: #222;
  text-align: left;
  .title {
    font-size: 30px;
    font-weight: 600;
    line-height: 40px;
  }
  .paragraph {
    font-size: 18px;
    line-height: 40px;
    margin-bottom: 40px;
    font-weight: 400;
  }
  .emphasize {
    font-weight: 600;
  }
  .logo {
    text-align: center;
    margin-bottom: 80px;
  }
}
</style>
